<script lang="ts">
  import { _ } from 'svelte-i18n';

  import ContactFilters from '$lib/components/ContactFilters.svelte';
  import { scheduleCount } from '$lib/stores/guided';
  import {
    hasEmail,
    hasFacebook,
    hasInstagram,
    hasLinkedin,
    hasPhone,
    hasTwitter,
    hasWebsite
  } from '$lib/stores/selection';

  /**
   * How the company can be reached.
   *
   * The sidebar's own control, embedded — see StepRegion for why that is worth
   * doing rather than building a second one.
   *
   * Watched rather than called, for the same reason: the component owns the
   * checkboxes, and threading a callback through seven of them to say what the
   * stores already say is not an improvement.
   */
  $: void ($hasWebsite,
  $hasEmail,
  $hasPhone,
  $hasLinkedin,
  $hasFacebook,
  $hasInstagram,
  $hasTwitter,
  scheduleCount());
</script>

<div class="space-y-4">
  <ContactFilters embedded />

  <p class="text-xs text-gray-500">{$_('guided.channels.hint')}</p>
</div>
